export default __webpack_public_path__ + "images/8fef7b4d9171db4fcbdb7214e5913e63.svg";